import { withInstall } from '@code-monkey-ui/utils'

import Transfer from './src/transfer.vue'

export const ElTransfer = withInstall(Transfer)
export default ElTransfer

export * from './src/transfer'
